import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all stockItemsQuantitieses
export const getStockItemsQuantities = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/stock-items-quantities`);
    return response.data;
  } catch (error) {
    console.error("Error fetching stock-items-quantities:", error.response?.data || error);
    throw error;
  }
};

// GET a single stockItemsQuantities
export const getStockItemsQuantitiesById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/stock-items-quantities/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching stock-items-quantities:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new stockItemsQuantities
export const createStockItemsQuantities = async (stockItemsQuantitiesData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/stock-items-quantities`, stockItemsQuantitiesData);
    return response.data;
  } catch (error) {
    console.error("Error creating stock-items-quantities:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing stockItemsQuantities
export const updateStockItemsQuantities = async (id, stockItemsQuantitiesData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/stock-items-quantities/${id}`, stockItemsQuantitiesData);
    return response.data;
  } catch (error) {
    console.error("Error updating stock-items-quantities:", error.response?.data || error);
    throw error;
  }
};

// DELETE a stockItemsQuantities
export const deleteStockItemsQuantities = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/stock-items-quantities/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting stock-items-quantities:", error.response?.data || error);
    throw error;
  }
};
